// extracted by mini-css-extract-plugin
export var modalFooter = "_mx-0";